var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Int } from './Int';
var UnsafeString = /** @class */ (function (_super) {
    __extends(UnsafeString, _super);
    function UnsafeString(length) {
        var _this = _super.call(this) || this;
        _this._length = length;
        _this._int = new Int();
        return _this;
    }
    UnsafeString.prototype.encodeBuffer = function (value, buffer) {
        value = String(value);
        if (!this._length) {
            this._int.encodeBuffer(value.length, buffer);
        }
        buffer.writeChars(value);
    };
    UnsafeString.prototype.decodeBuffer = function (buffer) {
        return buffer.readChars(this._length || this._int.decodeBuffer(buffer));
    };
    return UnsafeString;
}(Type));
export { UnsafeString };
